import { validationMessages } from './validationMessages.schema';

export default {
  title: 'Decyzja',
  type: 'object',
  properties: {
    comment: {
      title: 'Komentarz',
      type: 'string'
    },
    startDate: {
      title: 'Początek obowiązywnia',
      type: 'string',
      format: 'date',
      fieldRequired: true
    },
    endDate: {
      title: 'Koniec obowiązywania',
      type: 'string',
      format: 'date',
      fieldRequired: true
    },
    documentId: { type: 'number' },
    name: { type: 'string' },
    type: { type: 'string' },
    positive: { type: 'boolean' },
    dateRanges: {
      type: 'array',
      title: 'Przedziały dat',
      items: {
        type: 'object',
        title: 'Przedział dat',
        properties: {
          amount: {
            title: 'Kwota',
            type: 'number',
            fieldRequired: false
          },
          startDate: {
            title: 'Początek obowiązywnia',
            type: 'string',
            format: 'date',
            fieldRequired: true
          },
          endDate: {
            title: 'Koniec obowiązywania',
            type: 'string',
            format: 'date',
            fieldRequired: false
          },
          type: {
            title: 'Typ',
            type: 'string',
            fieldRequired: true
          }
        }
      }
    },
    dataDateRanges: {
      type: 'object',
      fieldRequired: false,
      properties: {
        benefitDateRanges: {
          fieldRequired: false,
          type: 'array',
          items: {
            type: 'object',
            fieldRequired: false,
            properties: {
              startDate: {
                title: 'Początek obowiązywnia',
                type: 'string',
                format: 'date',
                fieldRequired: true
              },
              endDate: {
                title: 'Koniec obowiązywania',
                type: 'string',
                format: 'date',
                fieldRequired: true
              },
              type: {
                title: 'Typ',
                type: 'number',
                fieldRequired: true
              }
            }
          }
        }
      }
    },
    data: {
      type: 'object',
      properties: {
        amount: {
          title: 'Przyznana kwota',
          type: 'number',
          fieldRequired: false
        }
      }
    }
  },
  allOf: [validationMessages]
};
